import React from 'react';
import { FormData } from '../types/formTypes';

interface CareerUpPlanFormProps {
  formData: FormData;
  updateFormData: (updates: Partial<FormData>) => void;
}

const CareerUpPlanForm: React.FC<CareerUpPlanFormProps> = ({ formData, updateFormData }) => {
  return (
    <div className="form-section">
      <h2>キャリアアップ計画（正社員化コース）</h2>
      <p className="form-description">
        上記の訓練を修了した非正規雇用労働者の正社員転換の実施につき、次のとおり届けます。
      </p>
      
      <div className="form-group">
        <div className="radio-group">
          <label>
            <input
              type="checkbox"
              checked={formData.careerUpPlan?.hasCareerUpManager || false}
              onChange={(e) => updateFormData({
                careerUpPlan: {
                  ...formData.careerUpPlan,
                  hasCareerUpManager: e.target.checked,
                  careerUpManagerName: formData.careerUpPlan?.careerUpManagerName || '',
                  hasCareerUpPlan: formData.careerUpPlan?.hasCareerUpPlan || false,
                  implementationYear: formData.careerUpPlan?.implementationYear || '',
                  implementationMonth: formData.careerUpPlan?.implementationMonth || '',
                }
              })}
            />
            キャリアアップ管理者を設置する
          </label>
        </div>
        <p className="form-note">※労働者代表との兼任はできません</p>
        
        {formData.careerUpPlan?.hasCareerUpManager && (
          <div className="form-group">
            <label htmlFor="careerUpManagerName">キャリアアップ管理者氏名</label>
            <input
              type="text"
              id="careerUpManagerName"
              value={formData.careerUpPlan?.careerUpManagerName || ''}
              onChange={(e) => updateFormData({
                careerUpPlan: {
                  ...formData.careerUpPlan,
                  hasCareerUpManager: formData.careerUpPlan?.hasCareerUpManager || false,
                  careerUpManagerName: e.target.value,
                  hasCareerUpPlan: formData.careerUpPlan?.hasCareerUpPlan || false,
                  implementationYear: formData.careerUpPlan?.implementationYear || '',
                  implementationMonth: formData.careerUpPlan?.implementationMonth || '',
                }
              })}
              placeholder="管理者の氏名を入力してください"
            />
          </div>
        )}
      </div>
      
      <div className="form-group">
        <div className="radio-group">
          <label>
            <input
              type="checkbox"
              checked={formData.careerUpPlan?.hasCareerUpPlan || false}
              onChange={(e) => updateFormData({
                careerUpPlan: {
                  ...formData.careerUpPlan,
                  hasCareerUpManager: formData.careerUpPlan?.hasCareerUpManager || false,
                  careerUpManagerName: formData.careerUpPlan?.careerUpManagerName || '',
                  hasCareerUpPlan: e.target.checked,
                  implementationYear: formData.careerUpPlan?.implementationYear || '',
                  implementationMonth: formData.careerUpPlan?.implementationMonth || '',
                }
              })}
            />
            人材開発支援助成金の訓練を修了した非正規雇用労働者を正社員転換する
          </label>
        </div>
        
        {formData.careerUpPlan?.hasCareerUpPlan && (
          <div className="career-up-date-input" style={{ marginTop: '10px' }}>
            <span>（</span>
            <input
              type="text"
              value={formData.careerUpPlan?.implementationYear || ''}
              onChange={(e) => updateFormData({
                careerUpPlan: {
                  ...formData.careerUpPlan,
                  hasCareerUpManager: formData.careerUpPlan?.hasCareerUpManager || false,
                  careerUpManagerName: formData.careerUpPlan?.careerUpManagerName || '',
                  hasCareerUpPlan: formData.careerUpPlan?.hasCareerUpPlan || false,
                  implementationYear: e.target.value,
                  implementationMonth: formData.careerUpPlan?.implementationMonth || '',
                }
              })}
              placeholder="2024"
            />
            <span>年</span>
            <input
              type="text"
              value={formData.careerUpPlan?.implementationMonth || ''}
              onChange={(e) => updateFormData({
                careerUpPlan: {
                  ...formData.careerUpPlan,
                  hasCareerUpManager: formData.careerUpPlan?.hasCareerUpManager || false,
                  careerUpManagerName: formData.careerUpPlan?.careerUpManagerName || '',
                  hasCareerUpPlan: formData.careerUpPlan?.hasCareerUpPlan || false,
                  implementationYear: formData.careerUpPlan?.implementationYear || '',
                  implementationMonth: e.target.value,
                }
              })}
              placeholder="12"
              style={{ width: '40px', textAlign: 'center' }}
            />
            <span>月頃実施予定）</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default CareerUpPlanForm;